import type { IAction } from '../../action/IAction'
import type { Order } from '../Order'
import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

export interface IUpdateOrCreateOrderByCustomer extends IAction<Order, UpdateOrCreateOrderByCustomerArgs> {}
@InputType()
export class UpdateOrCreateOrderByCustomerArgs extends ActionArgs {
  @Field(() => String)
  customerId: string

  @Field(() => String, { nullable: true })
  orderId: string

  @Field(() => String)
  email: string

  @Field(() => String, { nullable: true })
  name: string

  @Field(() => String, { nullable: true })
  companyId: string

  @Field(() => String, { nullable: true })
  companyName: string

  @Field(() => Boolean, { nullable: true })
  skipDomain: boolean
}
